import { render, staticRenderFns } from "./serviceitem-dialog-selector.vue?vue&type=template&id=1cf1e99c&"
import script from "./serviceitem-dialog-selector.vue?vue&type=script&lang=js&"
export * from "./serviceitem-dialog-selector.vue?vue&type=script&lang=js&"
import style0 from "./serviceitem-dialog-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports